import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { ordenCompraAdminLst } from 'src/app/models/ordenCompraLst';
import { IndexDetalleOrdenCompraAdminComponent } from '../index-detalle-orden-compra-admin/index-detalle-orden-compra-admin.component';

@Component({
  selector: 'app-index-orden-compra-admin',
  templateUrl: './index-orden-compra-admin.component.html',
  styleUrls: ['./index-orden-compra-admin.component.scss'],
})
export class IndexOrdenCompraAdminComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public ordenCompraSvc: OrdenCompraService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: ordenCompraAdminLst[] = [];
    this.displayedColumns = [
      'empresa',
      'fechaCreacion',
      'fechaFinalizada',
      'numeroRegistros',
      'estado',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<ordenCompraAdminLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.getOrdenesCompra(0, 10);
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getOrdenesCompra(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.ordenCompraSvc
      .getOrdenesCompraAdminActivas(page, numReg, this.searchString)
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<ordenCompraAdminLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getOrdenesCompra(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getOrdenesCompra(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getOrdenesCompra(this.pageIndex, this.pageSize);
  }

  /*   edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditOrdenCompraComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getOrdenesCompra(this.pageIndex, this.pageSize);
      }
    });
  } */

  /*   delete(obj: any) {
    console.log(obj);
    this.alertify.confirm(
      'Confirma que quiere eliminar el la orden de compra?',
      () => {
        this.ordenCompraSvc.deleteOrdenCompra(obj.id).subscribe((res) => {
          if (res) {
            this.getOrdenesCompra(this.pageIndex, this.pageSize);
            this.alertify.success('Hoario eliminado.');
          } else {
            this.alertify.error('La orden de compra no se ha podido eliminar.');
          }
        });
      }
    );
  } */

  abrirModalDeportistas(obj: any): void {
    let dialogRef = this.dialog.open(IndexDetalleOrdenCompraAdminComponent, {
      data: obj.id,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getOrdenesCompra(this.pageIndex, this.pageSize);
      }
    });
  }

  

  finalizar(obj: any): void {
    this.alertify.confirm(
      'Confirma la finalización de la orden de compra?',
      () => {
        this.ordenCompraSvc.finalizarOrdenCompra(obj.id).subscribe((result) => {
          if (result) {
            this.getOrdenesCompra(this.pageIndex, this.pageSize);
            this.alertify.success('Orden de compra finalizada');
          } else {
            this.alertify.error('La orden de compra no se puede finalizar');
          }
        });
      }
    );
  } 

  rechazar(obj: any): void {
    this.alertify.confirm(
      'Confirma el rechazo de la orden de compra?',
      () => {
        this.ordenCompraSvc.rechazarOrdenCompra(obj.id).subscribe((result) => {
          if (result) {
            this.getOrdenesCompra(this.pageIndex, this.pageSize);
            this.alertify.success('Orden de compra rechazada');
          } else {
            this.alertify.error('La orden de compra no se puede rechazar');
          }
        });
      }
    );
  } 

  getValorOrdenCompraFinal(obj: any) {
    this.ordenCompraSvc
      .getValorOrdenCompraAdmin(obj.id)
      .subscribe((valorOc) => {
        console.log('el valor final de la orden es:', valorOc);
        this.alertify.confirm(
          'El valor de la orden de compra es: $' +
            valorOc.toLocaleString('es-ES'),
          () => {}
        );
      });
  }
}
